import { IFrameworkStrings } from "framework/localization/IFrameworkStrings";
import { useContext } from "react";
import { SpecificLocalizationContext } from "./SpecificLocalizationContext";

export function useLocalization(): IFrameworkStrings {
    return useContext(SpecificLocalizationContext).strings;
}